module.exports = __webpack_public_path__ + "img/home_four_005.430a494e.png";